/**
 * Post form condition selector component.
 */
export default function (currentSelection) {
    return {
        currentSelection,
        select: function (type) {
            this.currentSelection = type;
            window.livewire.emitTo('posts.create-post-form', 'selectConditionType', type);
        },
    };
}
